export const langColors = {
    javascript: '#F1E05A',
    typescript: '#3178C6',
    python: '#3572A5',
    html: '#E34C26',
    css: '#563D7C',
    scss: '#C6538C',
    sass: '#A53B70',
    php: '#4F5D95',
    ruby: '#701516',
    swift: '#F05138',
    java: '#B07219',
    go: '#6AD7E5',
    shell: '#89E051',
    scala: '#C22D40',
    kotlin: '#A97BFF',
    dart: '#00B4AB',
    c: '#555555',
    'c#': '#EFEFEF',
    'c++': '#F34B7D',
    'objective-c': '#438EFF',
};